import React from "react";

const Shimmer = () => {
    return (
        <div className="shimmer-container">
            <div className="shimmer"></div>
            <div className="shimmer"></div>
            <div className="shimmer"></div>
            <div className="shimmer"></div>
            <div className="shimmer"></div>
            <div className="shimmer"></div>
            <div className="shimmer"></div>
            <div className="shimmer"></div>
            <div className="shimmer"></div>
            <div className="shimmer"></div>
            <div className="shimmer"></div>
            <div className="shimmer"></div>
        </div>
    );
};

export default Shimmer;

